// Slides route — renders the whiteboard shell in slides mode.
// Downstream whiteboard components now derive slides mode from the route name
// (SLIDES_VIEW) rather than from a ?slides=true query param, so no query-param
// bridge is needed.

import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import { WhiteboardRouteComponentLoader } from './WhiteboardRouteComponentLoader.tsx';

export const SlidesRoute: {
	(match: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(routeMatch: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					contentId: string;
					focusedCommentId: string | string[] | undefined;
					focusedMentionId: string | string[] | undefined;
				};
			};
			pageState: {
				contentId: string;
				spaceKey: string;
				contentType: string;
				routeName: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			isViewPage: boolean;
		};
	};
} = (match: RouteMatch): React.JSX.Element => {
	const {
		params: { contentId, spaceKey },
	} = match;

	return <WhiteboardRouteComponentLoader spaceKey={spaceKey} contentId={contentId} />;
};

SlidesRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey },
	query: { focusedCommentId, focusedMentionId },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				contentId: string;
				focusedCommentId: string | string[] | undefined;
				focusedMentionId: string | string[] | undefined;
			};
		};
		pageState: {
			contentId: string;
			spaceKey: string;
			contentType: string;
			routeName: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
		isViewPage: boolean;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'slideScreen',
			id: contentId,
			attributes: {
				contentId,
				focusedCommentId,
				focusedMentionId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentType: 'slide',
			routeName,
		},
	},
	MainLayout: { navView: CONTAINER_HOME_ID, spaceKey, isViewPage: true },
});
